import type {HovercardAttributesResult} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {ProfileReference} from '@github-ui/profile-reference'
import {Link} from '@primer/react'
import {clsx} from 'clsx'
import {graphql, useFragment} from 'react-relay'

import {VALUES} from '../constants/values'
import type {IssueBodyHeaderAuthor$key} from './__generated__/IssueBodyHeaderAuthor.graphql'
import styles from './IssueBodyHeaderAuthor.module.css'

export function IssueBodyHeaderAuthor({
  author,
  authorHovercardAttrs,
}: {
  author: IssueBodyHeaderAuthor$key | null
  authorHovercardAttrs?: HovercardAttributesResult
}) {
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment IssueBodyHeaderAuthor on Actor {
        login
        profileUrl
        ... on User {
          name
        }
        ... on EnterpriseUserAccount {
          name
        }
        ... on Mannequin {
          name
        }
      }
    `,
    author,
  )

  const {login, name, profileUrl} = data || VALUES.ghost
  return (
    <Link
      href={profileUrl || undefined}
      {...authorHovercardAttrs}
      data-testid="issue-body-header-author"
      className={clsx(styles.authorLoginLink, !profileUrl && styles.noProfileLink)}
    >
      <ProfileReference login={login} profileName={name} isAgent={false} />
    </Link>
  )
}
